import { appColors, Tier, TIERS } from '@backrs_ui/common-ui';

type TopTierBoxProps = Readonly<{
  isHighlighted: boolean;
  onClick: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
  setHoveredBox: (tier: Tier | null) => void;
  isHovered: boolean;
}>;
export const TopTierBox = ({
  isHighlighted,
  onClick,
  isHovered,
  setHoveredBox,
}: TopTierBoxProps) => {
  return (
    <>
      <rect
        x="522"
        y="450"
        width="155"
        height="89"
        rx="6"
        fill={isHighlighted ? '#5090FF' : '#D5E4FF'}
        onClick={onClick}
        cursor="pointer"
        onMouseEnter={() => setHoveredBox(TIERS.TOP)}
        onMouseLeave={() => setHoveredBox(null)}
      />
      <path
        d="M562.66 482.672H559.364V480.8H568.532V482.672H565.236V492H562.66V482.672ZM576.109 492.16C575.042 492.16 574.125 491.931 573.357 491.472C572.589 491.013 572.002 490.352 571.597 489.488C571.192 488.624 570.989 487.595 570.989 486.4C570.989 485.205 571.192 484.176 571.597 483.312C572.002 482.448 572.589 481.787 573.357 481.328C574.125 480.869 575.042 480.64 576.109 480.64C577.176 480.64 578.093 480.869 578.861 481.328C579.629 481.787 580.216 482.448 580.621 483.312C581.026 484.176 581.229 485.205 581.229 486.4C581.229 487.595 581.026 488.624 580.621 489.488C580.216 490.352 579.629 491.013 578.861 491.472C578.093 491.931 577.176 492.16 576.109 492.16ZM576.109 490.128C576.898 490.128 577.517 489.797 577.965 489.136C578.424 488.475 578.653 487.563 578.653 486.4C578.653 485.237 578.424 484.325 577.965 483.664C577.517 483.003 576.898 482.672 576.109 482.672C575.32 482.672 574.696 483.003 574.237 483.664C573.789 484.325 573.565 485.237 573.565 486.4C573.565 487.563 573.789 488.475 574.237 489.136C574.696 489.797 575.32 490.128 576.109 490.128ZM584.496 480.8H588.368C589.712 480.8 590.731 481.109 591.424 481.728C592.128 482.336 592.48 483.237 592.48 484.432C592.48 485.691 592.123 486.645 591.408 487.296C590.704 487.947 589.664 488.272 588.288 488.272H587.072V492H584.496V480.8ZM588.464 486.24C588.955 486.24 589.328 486.091 589.584 485.792C589.84 485.493 589.968 485.061 589.968 484.496C589.968 483.952 589.829 483.541 589.552 483.264C589.285 482.987 588.885 482.848 588.352 482.848H587.072V486.24H588.464ZM595.083 486.976H599.883V488.512H595.083V486.976ZM605.481 482.672H602.185V480.8H611.353V482.672H608.057V492H605.481V482.672ZM614.706 480.8H617.282V492H614.706V480.8ZM621.442 480.8H629.106V482.848H624.018V485.104H628.562V487.152H624.018V489.952H629.106V492H621.442V480.8ZM632.437 480.8H636.549C639.119 480.8 640.405 481.856 640.405 483.968C640.405 484.693 640.255 485.317 639.957 485.84C639.669 486.363 639.247 486.752 638.693 487.008V487.04C638.885 487.179 639.034 487.312 639.141 487.44C639.247 487.568 639.333 487.707 639.397 487.856L641.029 492H638.309L637.061 488.656C636.943 488.357 636.789 488.16 636.597 488.064C636.415 487.968 636.085 487.92 635.605 487.92H635.013V492H632.437V480.8ZM636.261 485.888C636.783 485.888 637.183 485.755 637.461 485.488C637.749 485.211 637.893 484.816 637.893 484.304C637.893 483.333 637.338 482.848 636.229 482.848H635.013V485.888H636.261Z"
        fill={isHighlighted ? appColors.neutral.white : appColors.color.blue1}
        onClick={onClick}
        cursor="pointer"
        opacity={isHovered ? 0.5 : 1}
        onMouseEnter={() => setHoveredBox(TIERS.TOP)}
        onMouseLeave={() => setHoveredBox(null)}
      />
      <text
        x="563"
        y="508"
        fill={isHighlighted ? appColors.neutral.white : appColors.color.blue1}
        fontSize="14"
        fontWeight="light"
        fontFamily="Sarabun"
        onClick={onClick}
        style={{ userSelect: 'none', cursor: 'pointer' }}
        opacity={isHovered ? 0.5 : 1}
        onMouseEnter={() => setHoveredBox(TIERS.TOP)}
        onMouseLeave={() => setHoveredBox(null)}
      >
        professional
      </text>
    </>
  );
};
